
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";

import { QrCodeObject } from "@/models/QrCodeObject";
import getReportService from "@/services/ReportService";

import CheckBox from "@/components/Checkbox.vue";
import CloseButton from "@/components/buttons/CloseButton.vue";

export default {
    name: "ReportContentPopin",
    components: { CheckBox, CloseButton },
    emits: ["close"],
    props: {
        qrcodeObject: {
            type: Object,
            required: true
        },
        videoUrl: String
    },
    setup(props: { qrcodeObject: QrCodeObject; videoUrl: string }, { emit }) {
        const store = useStore();

        const emailRegex = /^[a-z-_.0-9]+@([a-z-_0-9]+\.)+[a-z-_0-9]{2,}$/;
        const { t } = useI18n({ useScope: "global" });
        const reportSent = ref(false);
        const selectedReason = ref("");
        const availableReasons = [
            "HATE",
            "NUDITY_SEX",
            "ANIMAL_CRUELTY",
            "SUICIDE_SELF_INJURY",
            "BULLYING",
            "FAKE_NEWS",
            "VIOLENCE",
            "SCAM",
            "SALE_ILLEGAL",
            "INTELLECTUAL_VIOLATION",
            "CHILDREN_SAFETY"
        ];
        const keepUserInformed = ref(false);
        const firstName = ref("");
        const lastName = ref("");
        const email = ref("");
        const message = ref("");

        const error = ref("");

        function selectReason(reason: string) {
            selectedReason.value = reason;
        }

        async function submitForm() {
            error.value = "";

            if (keepUserInformed.value) {
                if (!email.value.length) {
                    error.value = t("report.errors.emailFieldRequiredField");
                    return;
                } else if (!emailRegex.test(email.value)) {
                    error.value = t("report.errors.invalidEmail");
                    return;
                }
            }

            const properties = {
                reason: selectedReason.value,
                videoUrl: props.videoUrl,
                reporterEmail: email.value.length ? email.value : undefined,
                reporterFirstName: firstName.value.length ? firstName.value : undefined,
                reporterLastName: lastName.value.length ? lastName.value : undefined,
                reporterMessage: message.value.length ? message.value : undefined
            };

            const data = await getReportService().createReport(
                props.qrcodeObject.qrcodeId,
                properties
            );

            if (data?.success === true) {
                this.reportSent = true;
                store.dispatch("qrcode/load", props.qrcodeObject.qrcodeId);
            } else if (data?.code?.length) {
                error.value = t("report.errors." + data.code);
            } else {
                error.value = t("report.errors.unknownError");
            }
        }

        function close() {
            emit("close");
        }

        return {
            submitForm,
            close,
            selectReason,
            availableReasons,
            error,
            selectedReason,
            keepUserInformed,
            firstName,
            lastName,
            email,
            message,
            reportSent
        };
    }
};
